export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const CLEAR_STORE = 'CLEAR_STORE';
export const ANGULAR_AUTH_SUCCESS = 'ANGULAR_AUTH_SUCCESS';
